import { getMerchantId } from '../utils/merchant';

export function shouldLoadProductCatalog(state = {}) {
  const merchantId = getMerchantId(state.auth?.merchant);
  if (!merchantId || state.products?.isReceiving) {
    return false;
  }

  if (!state.products?.catalogLoaded) {
    return true;
  }

  return state.products.loadedMerchantId !== merchantId;
}

export function loadProductCatalogIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (!shouldLoadProductCatalog(state)) {
      return;
    }

    const merchantId = getMerchantId(state.auth?.merchant);
    if (!merchantId) {
      return;
    }

    return import('./products').then(({ getProductsRequest }) => {
      if (typeof getProductsRequest !== 'function') {
        console.error('[products] getProductsRequest is unavailable — check action module imports.');
        return;
      }

      return dispatch(getProductsRequest(merchantId));
    });
  };
}
